<template>
  <div
    class="c-landing-page-hero"
    :class="lpHeroClass"
  >
    <hero
      v-bind="$attrs"
      :landing-page-hero="true"
    />
  </div>
</template>

<script>
import Hero from "./Hero.vue";
export default {
  components: { Hero },
  props: {
    values: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    lpHeroClass(){
      let result = []
      const heroData = this.$attrs
      if(heroData && heroData.cta && heroData.cta.text) {
        result = ['c-landing-page-hero--cta']
      }
      return result
    }
  }
};
</script>

<style lang="scss" scoped>
.c-landing-page-hero {
  @include respond(tab-port) {
    height: rem(600px);

  }
  @include respond(tab-land) {
    height: rem(600px);
    display: none;
  }
  &--cta {
    @include respond(tab-land) {
      height: rem(650px);
    }
    @include respond(tab-port) {
      height: rem(700px);
    }
    @include respond(phone) {
      height: rem(700px);
    }
  }
}
</style>
